import { render, staticRenderFns } from "./BtnFlag.vue?vue&type=template&id=564006b2&"
import script from "./BtnFlag.vue?vue&type=script&lang=js&"
export * from "./BtnFlag.vue?vue&type=script&lang=js&"
import style0 from "./BtnFlag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports